import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { CtaButton } from "@/components/CtaButton";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { SITE } from "@/constants/testIds";

export default function FaqPage() {
    const [faqs, setFaqs] = useState([]);
    useEffect(() => {
        api.faqs().then(setFaqs).catch(() => {});
    }, []);

    return (
        <div>
            <PageHeader
                eyebrow="FREQUENTLY ASKED"
                title="Questions, answered"
                subtitle="A few of the things people ask before their first visit. If you can’t find your answer, send us a note — we’re happy to help."
                breadcrumbs={[{ label: "Home", to: "/" }, { label: "FAQ" }]}
            />

            <section className="py-12 sm:py-16">
                <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
                    <Accordion
                        data-testid={SITE.faqAccordion}
                        type="single"
                        collapsible
                        className="divide-y divide-border/80 rounded-2xl border border-border/80 bg-white/85"
                    >
                        {faqs.map((f) => (
                            <AccordionItem
                                key={f.id}
                                value={f.id}
                                data-testid={SITE.faqItem}
                                className="border-0 px-5 sm:px-6"
                            >
                                <AccordionTrigger className="py-5 text-left font-display text-base sm:text-lg text-moss hover:text-terracotta hover:no-underline">
                                    {f.question}
                                </AccordionTrigger>
                                <AccordionContent className="pb-5 text-sm text-foreground/80 leading-relaxed">
                                    {f.answer}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>

                    <div className="mt-10 text-center">
                        <p className="text-foreground/70">Still have a question?</p>
                        <div className="mt-3 inline-flex">
                            <CtaButton to="/contact">Get in touch</CtaButton>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
